module.exports = __webpack_public_path__ + "img/ic_point_wh.0db53b2c.svg";